export default __webpack_public_path__ + "static/media/8_fooddiary__march.2a62bba9.jpg";